import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const MemberLocaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberLocale"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MemberLocale","document":MemberLocaleDocument}} as const;
export type MemberLocaleQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MemberLocaleQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id'>
    & { prefs?: Types.Maybe<(
      { __typename: 'Member_Prefs' }
      & Pick<Types.Member_Prefs, 'locale'>
    )> }
  )> }
);

/**
 * __useMemberLocaleQuery__
 *
 * To run a query within a React component, call `useMemberLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberLocaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberLocaleQuery(
  baseOptions?: TrelloQueryHookOptions<
    MemberLocaleQuery,
    MemberLocaleQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: MemberLocaleDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<MemberLocaleQuery, MemberLocaleQueryVariables>(
    MemberLocaleDocument,
    options,
  );
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useMemberLocaleLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    MemberLocaleQuery,
    MemberLocaleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemberLocaleQuery, MemberLocaleQueryVariables>(
    MemberLocaleDocument,
    options,
  );
}
export function useMemberLocaleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        MemberLocaleQuery,
        MemberLocaleQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MemberLocaleQuery, MemberLocaleQueryVariables>(
    MemberLocaleDocument,
    options,
  );
}
export type MemberLocaleQueryHookResult = ReturnType<
  typeof useMemberLocaleQuery
>;
export type MemberLocaleLazyQueryHookResult = ReturnType<
  typeof useMemberLocaleLazyQuery
>;
export type MemberLocaleSuspenseQueryHookResult = ReturnType<
  typeof useMemberLocaleSuspenseQuery
>;
export type MemberLocaleQueryResult = Apollo.QueryResult<
  MemberLocaleQuery,
  MemberLocaleQueryVariables
>;
